import TR from 'utils/TR';
import useNavAction from 'hooks/actions/useNavAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import HBox from 'components/common/HBox';

export default function SimulationDietTabs(props) {
  const {
    children,
    ...rest
  } = props;

  const {
    triggered: triggeredSimulationDietTable,
    onTrigger: onTriggerSimulationDietTable,
  } = useNavAction({ name: 'SimulationDietTable' }, props);

  const {
    triggered: triggeredSimulationDietGraph,
    onTrigger: onTriggerSimulationDietGraph,
  } = useNavAction({ name: 'SimulationDietGraph' }, props);

  return (
    <HBox between {...ex('SimulationDietTabs', rest)}>
      <HBox>
        <FocusableButton
          {...ex(['ViewModeButton', { triggered: triggeredSimulationDietTable }], {
            disabled: triggeredSimulationDietTable,
            onClick: onTriggerSimulationDietTable(),
          })}
        >
          {T('테이블로 보기')}
        </FocusableButton>
        <FocusableButton
          {...ex(['ViewModeButton', { triggered: triggeredSimulationDietGraph }], {
            disabled: triggeredSimulationDietGraph,
            onClick: onTriggerSimulationDietGraph(),
          })}
        >
          {T('그래프로 보기')}
        </FocusableButton>
      </HBox>
    </HBox>
  );
}
